<div class="card card-default mt-3">
  <div class="card-body">
    <div class="row">
      <div class="col-12">
        <button class="btn btn-add">
          <span class="fa fa-plus-circle fa-lg"></span>
          New Case
        </button>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/ayBe7TigQlQ" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen></iframe>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/chatbot/chatbot.component.html